// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-Discounts-__Discounts___i42OQ","tableWrapper":"app-pages-Reports-Sales-Discounts-__Discounts___Zuq0S","tableWrapperResponsive":"app-pages-Reports-Sales-Discounts-__Discounts___23lI8"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Reports/Sales/Discounts/Discounts.css
// module id = 2215
// module chunks = 0